<form [formGroup]="signUpForm" (ngSubmit)="submitHandler()">
  <div class="grid gap-x-4 md:grid-cols-2">
    <app-shared-input
      label="First name"
      [for]="'firstName'"
      [value]="signUpForm.value.firstName"
      [focused]="focused === 'firstName'"
      [touched]="signUpForm.get('firstName')?.touched"
      [errors]="signUpForm.get('firstName')?.errors"
      [disabled]="loading"
    >
      <input
        formControlName="firstName"
        name="firstName"
        id="firstName"
        (focus)="focusHandler($event)"
        (blur)="blurHandler($event)"
      />
    </app-shared-input>
    <app-shared-input
      label="Last name"
      [for]="'surname'"
      [value]="signUpForm.value.surname"
      [focused]="focused === 'surname'"
      [touched]="signUpForm.get('surname')?.touched"
      [errors]="signUpForm.get('surname')?.errors"
      [disabled]="loading"
    >
      <input
        formControlName="surname"
        name="surname"
        id="surname"
        (focus)="focusHandler($event)"
        (blur)="blurHandler($event)"
      />
    </app-shared-input>
  </div>

  <app-shared-input
    label="Email"
    [for]="'email'"
    [value]="signUpForm.value.email"
    [focused]="focused === 'email'"
    [touched]="signUpForm.get('email')?.touched"
    [errors]="
      !emailAccountDeactivated && !emailAlreadyTaken
        ? signUpForm.get('email')?.errors
        : undefined
    "
    [disabled]="loading"
  >
    <input
      formControlName="email"
      id="email"
      name="email"
      type="email"
      (focus)="focusHandler($event)"
      (blur)="blurHandler($event)"
    />
  </app-shared-input>
  <div
    class="input-error-message custom"
    *ngIf="emailAccountDeactivated || emailAlreadyTaken"
  >
    <ng-container *ngIf="emailAccountDeactivated; else emailTaken">
      <ng-container [ngTemplateOutlet]="accountLocked"></ng-container>
    </ng-container>
    <ng-template #emailTaken>
      Email has already been taken.
      <span
        (click)="showSignInModal('email')"
        class="font-semibold underline cursor-pointer"
        >Sign in</span
      >
      instead.
    </ng-template>
  </div>

  <app-shared-input
    label="Phone number"
    [for]="'phoneNumber'"
    [value]="signUpForm.value.phoneNumber"
    [focused]="focused === 'phoneNumber'"
    [touched]="signUpForm.get('phoneNumber')?.touched"
    [errors]="
      !phoneNumberAccountDeactivated && !phoneNumberAlreadyTaken
        ? signUpForm.get('phoneNumber')?.errors
        : undefined
    "
    [disabled]="loading"
    prefix="+1"
  >
    <input
      formControlName="phoneNumber"
      name="phoneNumber"
      id="phoneNumber"
      type="tel"
      (paste)="pastePhoneNumberHandler($event)"
      (focus)="focusHandler($event)"
      (blur)="blurHandler($event)"
      mask="(000) 000-0000"
    />
  </app-shared-input>
  <div
    class="input-error-message custom"
    *ngIf="phoneNumberAccountDeactivated || phoneNumberAlreadyTaken"
  >
    <ng-container *ngIf="phoneNumberAccountDeactivated; else phoneTaken">
      <ng-container [ngTemplateOutlet]="accountLocked"></ng-container>
    </ng-container>
    <ng-template #phoneTaken>
      Phone number has already been taken.
      <span
        (click)="showSignInModal('phone-number')"
        class="font-semibold underline cursor-pointer"
        >Sign in</span
      >
      instead.
    </ng-template>
  </div>
  <p class="text-sm text-gray-500 dark:text-gray-400 -mt-3 mb-4">
    We will send an SMS verification link to your phone number
  </p>

  <app-shared-input
    [label]="
      !loadingInviteSources
        ? 'How did you hear about us?'
        : 'Loading invite sources...'
    "
    [selector]="true"
    for="inviteSource"
    [value]="signUpForm.value.inviteSource"
    [focused]="focused === 'inviteSource'"
    [touched]="signUpForm.get('inviteSource')?.touched"
    [errors]="signUpForm.get('inviteSource')?.errors"
    [disabled]="loading || loadingInviteSources"
  >
    <mat-select
      formControlName="inviteSource"
      [ngClass]="{
        'select-placeholder': !signUpForm.value.inviteSource
      }"
    >
      <ng-container *ngIf="!loadingInviteSources">
        <mat-option
          *ngFor="let source of inviteSources"
          [value]="source.id?.toUpperCase()"
        >
          {{ source.name }}
        </mat-option>
      </ng-container>
    </mat-select>
  </app-shared-input>

  <div class="terms-of-service">
    <mat-checkbox
      class="custom-checkbox"
      color="primary"
      formControlName="terms"
    >
      I agree to Rebuilt’s
      <a href="https://www.rebuilt.com/terms-of-use" target="_blank"
        >Terms of Use</a
      >
      and
      <a href="https://www.rebuilt.com/privacy-policy" target="_blank"
        >Privacy Policy.</a
      >
    </mat-checkbox>
  </div>
  <div
    *ngIf="
      this.signUpForm.controls['terms'].touched &&
      signUpForm.controls['terms'].hasError('required')
    "
    class="input-error-message terms-error"
  >
    You must agree to the terms of service to continue.
  </div>

  <div class="marketing-emails">
    <mat-checkbox
      class="marketing-checkbox"
      color="primary"
      formControlName="allowMarketingEmails"
    >
      By submitting a telephone number to us, you agree that a representative of
      Rebuilt can contact you at the number you provide, potentially using
      automated technology (including emails/SMS messaging) or a pre-recorded
      message. Your consent is not an obligation to receive any of our services.
    </mat-checkbox>
  </div>
  <div
    *ngIf="
      this.signUpForm.controls['allowMarketingEmails'].touched &&
      signUpForm.controls['allowMarketingEmails'].hasError('required')
    "
    class="input-error-message marketing-error"
  >
    You must agree to receive marketing emails/SMS to continue.
  </div>

  <div class="mt-4">
    <app-shared-button [loading]="loading"> Join for free </app-shared-button>
  </div>
</form>

<ng-template #accountLocked>
  Sorry, your account is locked. Please email
  <a href="mailto:help@rebuilt.com" class="font-semibold">help@rebuilt.com</a>
  for assistance.
</ng-template>
